module.exports = __webpack_public_path__ + "static/media/questionCircleDefault.428d3926.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-page/questionCircleDefault.svg
// module id = 58
// module chunks = 0